// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4221":"4b7dd870","5971":"2de62c34","7684":"79608586","7850":"650fae78"}[chunkId] + ".chunk.css";
};